export enum Authorities {
    PROFESSIONAL_AUTHORITY_UNSPECIFIED = 'Unbekannt',
    PROFESSIONAL_AUTHORITY_OWNER = 'Inhaber',
    PROFESSIONAL_AUTHORITY_EXECUTIVE = 'Geschäftsführer',
    PROFESSIONAL_AUTHORITY_ATTORNEY = 'Prokurist',
    PROFESSIONAL_AUTHORITY_ACTING_PERSON = 'Handelnde',
    PROFESSIONAL_AUTHORITY_MANAGEMENT = 'Vorstand',
}

export type ContactPurpose = 'CONTACT_PURPOSE_DEFAULT' | 'CONTACT_PURPOSE_INVOICE' | 'CONTACT_PURPOSE_SEPA';

export interface Email {
    value: string;
    purpose: ContactPurpose;
}

export interface PhoneNumber {
    value: string;
    purpose: ContactPurpose;
}

export interface Address {
    streetName: string;
    houseNumber: string;
    addressAddition?: string | null;
    postalCode?: string;
    city: string;
    country: string;
}

export interface ContactDetails {
    emails: Email[];
    phoneNumbers: PhoneNumber[];

    addresses: Address[];
}
export interface Person {
    title?: string | null;
    firstName: string;
    lastName: string;
    birthdate?: string | null;
    birthplace?: string | null;
    citizenship?: string | null;
    contactDetails?: ContactDetails | null;
    gender?: string | null;
    nationality?: string | null;
}
// Vertretungsberechtigte Personen (Geschäftsführer/Eigentümer)
export interface AuthorizedRepresentative {
    person?: Person;

    role?: Authorities[];
}

export interface AuthorizedRepresentativeView {
    firstName: string;

    lastName: string;

    role: string[];
}
